"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PredictionModelVizCardButtonId = void 0;
exports.PredictionModelVizCardButtonId = 'prediction-model-viz-card-button';
//# sourceMappingURL=TestIds.js.map